import { patternShape } from './_shared';
import { z } from 'zod';

export const builder_opened = z.object({}).strict();

export const builder_saved = patternShape.strict();
